/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuidReferenceReadModel } from './GuidReferenceReadModel';
import {
    GuidReferenceReadModelFromJSON,
    GuidReferenceReadModelFromJSONTyped,
    GuidReferenceReadModelToJSON,
    GuidReferenceReadModelToJSONTyped,
} from './GuidReferenceReadModel';

/**
 * 
 * @export
 * @interface GuidReferenceReadModelPagedList
 */
export interface GuidReferenceReadModelPagedList {
    /**
     * 
     * @type {number}
     * @memberof GuidReferenceReadModelPagedList
     */
    readonly totalCount: number;
    /**
     * 
     * @type {Array<GuidReferenceReadModel>}
     * @memberof GuidReferenceReadModelPagedList
     */
    readonly entities: Array<GuidReferenceReadModel>;
}

/**
 * Check if a given object implements the GuidReferenceReadModelPagedList interface.
 */
export function instanceOfGuidReferenceReadModelPagedList(value: object): value is GuidReferenceReadModelPagedList {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    return true;
}

export function GuidReferenceReadModelPagedListFromJSON(json: any): GuidReferenceReadModelPagedList {
    return GuidReferenceReadModelPagedListFromJSONTyped(json, false);
}

export function GuidReferenceReadModelPagedListFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidReferenceReadModelPagedList {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'entities': ((json['entities'] as Array<any>).map(GuidReferenceReadModelFromJSON)),
    };
}

export function GuidReferenceReadModelPagedListToJSON(json: any): GuidReferenceReadModelPagedList {
    return GuidReferenceReadModelPagedListToJSONTyped(json, false);
}

export function GuidReferenceReadModelPagedListToJSONTyped(value?: Omit<GuidReferenceReadModelPagedList, 'totalCount'|'entities'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

